<div mat-dialog-content>
  <!-- Hero Section with Stats -->
  <div class="modal-header-hero">
    <button mat-icon-button (click)="close()" style="position: absolute; top: 1rem; right: 1rem; color: rgba(255,255,255,0.8);">
      <mat-icon>close</mat-icon>
    </button>

    <div class="session-info">
      <span style="opacity: 0.8; font-size: 0.8rem; font-weight: 700; text-transform: uppercase;">{{ 'generic.session' | translate }}</span>
      <span class="session-num">{{ data.current_session_number }}</span>
      <div class="divider"></div>
      <span style="opacity: 1; font-size: 0.8rem; font-weight: 700; text-transform: uppercase; color: #fff;">{{ 'generic.new-session' | translate }}</span>
      <span class="session-num" style="color: #fff;">{{ data.next_session_number }}</span>
    </div>

    <div class="hero-stats-grid">
      <div class="hero-stat-item">
        <div class="val">{{ data.stats.total }}</div>
        <div class="lab">{{ 'modals.modal-survey-revision-preview.total-questions' | translate }}</div>
      </div>
      <div class="hero-stat-item">
        <div class="val" style="color: #4ade80;">{{ data.stats.will_be_included_in_revision }}</div>
        <div class="lab" style="color: #4ade80;">{{ 'modals.modal-survey-revision-preview.included' | translate }}</div>
      </div>
      <div class="hero-stat-item">
        <div class="val" style="color: #f87171;">{{ data.stats.will_be_excluded_from_revision }}</div>
        <div class="lab" style="color: #f87171;">{{ 'modals.modal-survey-revision-preview.excluded' | translate }}</div>
      </div>
      <div class="hero-stat-item">
        <div class="val" style="color: #fbbf24;">{{ data.stats.undecided }}</div>
        <div class="lab" style="color: #fbbf24;">{{ 'modals.modal-survey-revision-preview.undecided' | translate }}</div>
      </div>
    </div>
  </div>

  <div class="preview-content">
    <div class="row">
      <!-- Included Column -->
      <div class="col-md-6 mb-4">
        <div class="section-card">
          <div class="section-header">
            <h5>
              <mat-icon class="text-success mr-2" style="vertical-align: middle;">verified</mat-icon>
              {{ 'modals.modal-survey-revision-preview.included-questions' | translate }}
            </h5>
            <span class="badge bg-success-light text-success rounded-pill px-3">{{ data.included_questions.length }}</span>
          </div>
          <div class="scrollable-questions">
            @for (q of data.included_questions; track q) {
              <div class="q-item">
                <div class="q-text">{{ q.question }}</div>
                <div class="q-badge" [ngStyle]="{'background': surveyService.getDecisionColor(q.final_decision) + '15', 'color': surveyService.getDecisionColor(q.final_decision)}">
                  <mat-icon>{{ surveyService.getDecisionIcon(q.final_decision) }}</mat-icon>
                  {{ 'service.survey-service.question-final-decision-statuses.' + q.final_decision + '.title' | translate }}
                </div>
                @if (q.final_decision === 'revised' && q.revision_question?.question) {
                  <div class="q-compare">
                    <div class="q-compare-label">{{ 'modals.modal-survey-revision-preview.original' | translate }}</div>
                    <div class="q-original">{{ q.question }}</div>
                    <mat-icon class="q-compare-arrow">arrow_downward</mat-icon>
                    <div class="q-compare-label" [style.color]="surveyService.getDecisionColor('revised')">
                      {{ 'modals.modal-survey-revision-preview.new' | translate }}
                    </div>
                    <div class="q-new" [style.color]="surveyService.getDecisionColor('revised')">{{ q.revision_question.question }}</div>
                  </div>
                }
                @if (q.final_decision === 'revised_split' && q.split_questions?.length) {
                  <div class="q-compare">
                    <div class="q-compare-label">{{ 'modals.modal-survey-revision-preview.original' | translate }}</div>
                    <div class="q-original">{{ q.question }}</div>
                    <mat-icon class="q-compare-arrow">arrow_downward</mat-icon>
                    <div class="q-compare-label" [style.color]="surveyService.getDecisionColor('revised_split')">
                      {{ 'modals.modal-survey-revision-preview.new-statements' | translate }}
                    </div>
                    @for (sq of q.split_questions; track sq; let i = $index) {
                      <div class="q-new" [style.color]="surveyService.getDecisionColor('revised_split')">
                        <b>{{ i + 1 }}.</b> {{ sq.question }}
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (data.included_questions.length === 0) {
              <div class="p-5 text-center text-muted opacity-50 italic">
                {{ 'modals.modal-survey-revision-preview.no-questions' | translate }}
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Excluded Column -->
      <div class="col-md-6 mb-4">
        <div class="section-card">
          <div class="section-header">
            <h5>
              <mat-icon class="text-danger mr-2" style="vertical-align: middle;">block</mat-icon>
              {{ 'modals.modal-survey-revision-preview.excluded-questions' | translate }}
            </h5>
            <span class="badge bg-danger-light text-danger rounded-pill px-3">{{ data.excluded_questions.length }}</span>
          </div>
          <div class="scrollable-questions">
            @for (q of data.excluded_questions; track q) {
              <div class="q-item" [class.q-rejected]="q.final_decision === 'rejected'">
                <div class="q-text">{{ q.question }}</div>
                <div class="q-badge" [ngStyle]="{'background': surveyService.getDecisionColor(q.final_decision) + '15', 'color': surveyService.getDecisionColor(q.final_decision)}">
                  <mat-icon>{{ surveyService.getDecisionIcon(q.final_decision) }}</mat-icon>
                  {{ 'service.survey-service.question-final-decision-statuses.' + q.final_decision + '.title' | translate }}
                </div>
              </div>
            }
            @if (data.excluded_questions.length === 0) {
              <div class="p-5 text-center text-muted opacity-50 italic">
                {{ 'modals.modal-survey-revision-preview.no-questions' | translate }}
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="dialog-footer d-flex align-items-center">
    <span class="text-muted small italic">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; vertical-align: middle;" class="mr-1">info</mat-icon>
      {{ 'modals.modal-survey-revision-preview.footer-note' | translate }}
    </span>
    <span class="spacer"></span>
    <button mat-button class="btn-main cancel mr-3" (click)="close()">
      {{ 'generic.buttons.close' | translate }}
    </button>
    <button mat-button class="btn-main confirm" (click)="confirmRevision()">
      <mat-icon class="mr-2">rocket_launch</mat-icon>
      {{ 'modals.modal-survey-revision-preview.confirm-revision' | translate }}
    </button>
  </div>
</div>


